import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useToast } from '@ntconsult/aluma-react';
import { userService } from '../services/userService';

export function useDeleteUser() {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const { t } = useTranslation('users');

  return useMutation({
    mutationFn: (id: string) => userService.deleteUser(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] });
      toast.success({ title: t('toasts.deleteSuccess') });
    },
    onError: () => {
      toast.danger({ title: t('toasts.deleteError') });
    },
  });
}
